import * as React from "react";
import type { SVGProps } from "react";
const SvgGlobeIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="globe_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M406.187 187.392a341.717 341.717 0 0 0-232.918 281.941h127.872c9.686-100.821 45.995-197.418 104.96-281.941zm211.626 0c59.008 84.523 95.318 181.12 105.003 281.941h127.872a341.717 341.717 0 0 0-232.832-281.941zm19.2 281.941C625.536 368.085 582.4 271.275 512 190.293c-70.4 80.939-113.536 177.75-125.013 279.04h250.026zm-250.026 85.334C398.464 655.915 441.6 752.725 512 833.707c70.4-80.982 113.536-177.792 125.013-279.04H386.987zm-85.803 0H173.312a341.717 341.717 0 0 0 232.832 281.941c-58.965-84.523-95.275-181.12-104.917-281.941zm316.672 281.941a341.675 341.675 0 0 0 232.832-281.941H722.816c-9.685 100.821-45.995 197.418-104.96 281.941zM85.333 512C85.333 276.352 276.352 85.333 512 85.333S938.667 276.352 938.667 512 747.648 938.667 512 938.667 85.333 747.648 85.333 512z"
    />
  </svg>
);
export default SvgGlobeIcon;
